import { Badge, Button, Group, Stack, Text, TextInput } from '@mantine/core';
import { Controller } from 'react-hook-form';

import type { Control, FieldErrors, UseFormHandleSubmit, UseFormRegister } from 'react-hook-form';
import type { IRoleFormFields } from '../roleRegModal';

interface RoleRegFormPanelProps {
  companyName: string;
  control: Control<IRoleFormFields>;
  errors: FieldErrors<IRoleFormFields>;
  handleSubmit: UseFormHandleSubmit<IRoleFormFields>;
  isEditMode: boolean;
  isOrderDisabled: boolean;
  onReset: () => void;
  onSubmit: (data: IRoleFormFields) => void;
  register: UseFormRegister<IRoleFormFields>;
}

export default function RoleRegFormPanel(props: RoleRegFormPanelProps) {
  const { companyName, control, errors, handleSubmit, isEditMode, isOrderDisabled, onReset, onSubmit, register } = props;

  return (
    <>
      <Group mb={4}>
        <Text fw={500} size="sm">
          역할 정보
        </Text>
        {isEditMode && (
          <Badge variant="light" color="blue" size="md">
            수정 중
          </Badge>
        )}
      </Group>
      <Text size="xs" c="secondary" mb="sm">
        *은 필수 입력 항목입니다.
      </Text>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack>
          <TextInput withAsterisk label="회사" readOnly disabled value={companyName} />
          <TextInput
            withAsterisk
            label="역할명(국문)"
            placeholder="역할명을 입력하세요."
            error={errors.roleName?.message}
            {...register('roleName')}
          />
          <TextInput
            withAsterisk
            label="역할명(영문)"
            placeholder="역할명을 입력하세요."
            error={errors.roleNameEn?.message}
            {...register('roleNameEn')}
          />
          <Controller
            name="order"
            control={control}
            render={({ field }) => (
              <TextInput
                withAsterisk
                disabled={isOrderDisabled}
                label="순서"
                placeholder="숫자를 입력하세요."
                error={errors.order?.message}
                inputMode="numeric"
                value={field.value}
                onChange={(event) => field.onChange(event.currentTarget.value.replace(/\D/g, ''))}
                description={isOrderDisabled ? '최고관리자는 순서를 변경할 수 없습니다.' : '2부터 입력 가능합니다.'}
              />
            )}
          />
          <Group justify="center">
            {isEditMode ? (
              <Group justify="center">
                <Button type="button" variant="outline" onClick={onReset}>
                  초기화
                </Button>
                <Button type="submit" color="secondary">
                  수정
                </Button>
              </Group>
            ) : (
              <Button type="submit" color="secondary">
                생성
              </Button>
            )}
          </Group>
        </Stack>
      </form>
    </>
  );
}
